export default "__VITE_ASSET__UJ59vsHp__"